<script>
import ConversationCard from './widgets/conversation/ConversationCard.vue';
import EmailConversationCard from './widgets/conversation/EmailConversationCard.vue';
export default {
  components: {
    ConversationCard,
    EmailConversationCard,
  },
  inject: [
    'selectConversation',
    'deSelectConversation',
    'assignAgent',
    'assignSelf',
    'startConversation',
    'assignMine',
    'assignPersonal',
    'assignTeam',
    'assignLabels',
    'removeLabels',
    'updateConversationStatus',
    'toggleContextMenu',
    'markAsUnread',
    'markAsRead',
    'assignPriority',
    'togglePin',
    'isConversationSelected',
    'deleteConversation',
  ],
  props: {
    source: {
      type: Object,
      required: true,
    },
    teamId: {
      type: [String, Number],
      default: 0,
    },
    label: {
      type: String,
      default: '',
    },
    conversationType: {
      type: String,
      default: '',
    },
    foldersId: {
      type: [String, Number],
      default: 0,
    },
    showAssignee: {
      type: Boolean,
      default: false,
    },
    activeAssigneeTab: {
      type: String,
      default: '',
    },
  },
  computed: {
    // Aceleres 2026-09-14: so a inbox de e-mail troca de cartao; o resto segue
    // no ConversationCard sem nenhuma mudanca.
    isEmailConversation() {
      const inbox = this.$store.getters['inboxes/getInbox'](
        this.source.inbox_id
      );
      return inbox?.channel_type === 'Channel::Email';
    },
  },
};
</script>

<template>
  <EmailConversationCard
    v-if="isEmailConversation"
    :active-label="label"
    :team-id="teamId"
    :folders-id="foldersId"
    :chat="source"
    :conversation-type="conversationType"
    :active-assignee-tab="activeAssigneeTab"
    :selected="isConversationSelected(source.id)"
    @select-conversation="selectConversation"
    @de-select-conversation="deSelectConversation"
    @context-menu-toggle="toggleContextMenu"
    @update-conversation-status="updateConversationStatus"
    @assign-agent="assignAgent"
    @assign-self="assignSelf"
    @start-conversation="startConversation"
    @assign-mine="assignMine"
    @mark-as-unread="markAsUnread"
    @mark-as-read="markAsRead"
    @toggle-pin="togglePin"
  />
  <ConversationCard
    v-else
    :active-label="label"
    :team-id="teamId"
    :folders-id="foldersId"
    :chat="source"
    :conversation-type="conversationType"
    :active-assignee-tab="activeAssigneeTab"
    :selected="isConversationSelected(source.id)"
    :show-assignee="showAssignee"
    enable-context-menu
    @select-conversation="selectConversation"
    @de-select-conversation="deSelectConversation"
    @assign-agent="assignAgent"
    @assign-self="assignSelf"
    @start-conversation="startConversation"
    @assign-mine="assignMine"
    @assign-personal="assignPersonal"
    @assign-team="assignTeam"
    @assign-label="assignLabels"
    @remove-label="removeLabels"
    @update-conversation-status="updateConversationStatus"
    @context-menu-toggle="toggleContextMenu"
    @mark-as-unread="markAsUnread"
    @mark-as-read="markAsRead"
    @assign-priority="assignPriority"
    @toggle-pin="togglePin"
    @delete-conversation="deleteConversation"
  />
</template>
